var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForecast(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.247 21.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn-hydrologie",
    d: "M17.81,0a.687.687,0,0,0,0,1.375h2.062V5.156h-.687a.687.687,0,1,0,0,1.375h.687v3.781H17.81a.687.687,0,1,0,0,1.375h2.062v3.781h-.687a.687.687,0,1,0,0,1.375h.687v3.781H17.81a.687.687,0,0,0,0,1.375h2.75a.687.687,0,0,0,.687-.687V.687A.687.687,0,0,0,20.56,0ZM8.874,2.062l.5-.472a.687.687,0,0,0-1,0l0,0-.008.01-.03.032-.11.121Q7.311,2.768,6.471,3.841A29.1,29.1,0,0,0,3.192,8.965,10.6,10.6,0,0,0,2,13.381a7.065,7.065,0,0,0,6.874,7.241,7.065,7.065,0,0,0,6.874-7.241,10.606,10.606,0,0,0-1.192-4.416,29.1,29.1,0,0,0-3.279-5.124Q10.388,2.7,9.416,1.635L9.386,1.6l-.008-.01h0Zm0,0-.5-.472ZM8.852,3.115l.022-.026.022.026c.33.377.786.917,1.3,1.573a30.277,30.277,0,0,1,2.614,3.887H4.942A30.276,30.276,0,0,1,7.554,4.688c.513-.656.971-1.2,1.3-1.573ZM3.375,13.381A8.75,8.75,0,0,1,4.252,9.95H13.5a8.726,8.726,0,0,1,.877,3.432,5.692,5.692,0,0,1-5.5,5.866A5.692,5.692,0,0,1,3.375,13.381Z",
    transform: "translate(-2)",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.06a043df417210fc22624f827b9101a6.svg";
export { ForwardRef as ReactComponent };